
import { cn } from "@/lib/utils";

interface YearSelectorProps {
  currentYear: number;
  onYearChange: (year: number) => void;
  minYear?: number;
}

const YearSelector = ({ currentYear, onYearChange, minYear }: YearSelectorProps) => {
  const currentSystemYear = new Date().getFullYear();
  const startYear = minYear ?? currentSystemYear - 2;

  const availableYears: number[] = [];
  for (let y = currentSystemYear; y >= startYear; y--) {
    availableYears.push(y);
  }

  return (
    <div className="flex items-center gap-1.5 overflow-x-auto">
      {availableYears.map((year) => (
        <button
          key={year}
          className={cn(
            "px-2.5 py-1 rounded-full text-sm font-medium transition-colors shrink-0",
            currentYear === year
              ? "bg-forest text-white"
              : "text-muted-foreground hover:text-forest hover:bg-muted"
          )}
          onClick={() => onYearChange(year)}
        >
          {year}
        </button>
      ))}
    </div>
  );
};

export default YearSelector;
